export default __webpack_public_path__ + "static/media/AdobeStock_54337047_x3.af556bab.jpg";